import React, {Fragment} from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalCatLoteMediosSanitaria } from '../../../components/worksheetsanitary/ModalCatLoteMediosSanitaria';
import { useLisLot } from '../../../hooks/worksheetsanitary/useLisLot';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexListLot = () => {
    const{
        catlotessanitary, descripcion,n_lote, validaciones,
        method, 
        handleInputChange, handleSearchSample, loading, 
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        showDeleteAlert, closeDeleteAlert, modalAlert,
        handleClear, handleSearch, searchLote, loadingExport, handleExcelote

    } = useLisLot();
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_lote_sanitary)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_lote_sanitary)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    return(
        <>
            <Fragment>
                <Container fluid={true} className='container-global-zoom'>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody className="p-1">
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de Lote de Medios"
                                            buttonActions={handleExcelote}
                                            titleButton="Excel de lote de medios"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear lote"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchLote}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClear}
    
                                        />
                                    </Col>

                                    <div className="table-responsive">
                                        <DataTable
                                            value={catlotessanitary}
                                            paginator
                                            rows={15}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[15, 50, 100]} 
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
    
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column header="Descripción" body={(rowData) => (rowData?.descripcion || "---")} headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="n_lote" header="N° Lote" body={(rowData) => (rowData?.n_lote || "---")} headerStyle={headerStyle} style={cellStyle} />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {showDeleteAlert && (
                        <AlertDataTable
                            titleAlert="Eliminar lote de medios"
                            visibleAlert={modalAlert}
                            onHideAlert={closeDeleteAlert}
                            sizeAlert="medium-dialog delete-method"
                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el lote?"
                            alert1={true}
                            titleAlert1={descripcion}
                            buttonAcept
                            titleNotLoading="Eliminar"
                            titleDanger="Cancelar"
                            actionAcept={saveDelete}
                        />
    
                    )}
                </Container>
                <ModalCatLoteMediosSanitaria
                {
                    ...{
                        catlotessanitary, descripcion,n_lote, validaciones,
                        method, 
                        handleInputChange, handleSearchSample, loading, 
                        closeDialog, modal, modalTitle,
                        saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                    }
                }
                />
            </Fragment>
        </>
    )
}
